export const teamsConstants = {
    errors: {
        fetchFailed: "Failed to load teams.",
        createFailed: "Failed to create team.",
        updateFailed: "Failed to update team.",
        deleteFailed: "Failed to delete team.",
        genericError: "Something went wrong.",
    },
    messages: {
        createSuccess: "Team created successfully.",
        updateSuccess: "Team updated.",
        deleteSuccess: "Team deleted.",
    },
};
